import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { useVersionCheck } from '@/hooks/useVersionCheck';
import { useSidebar } from '@/components/ui/sidebar';

export function NavVersionCard() {
  const { newVersionAvailable, refreshApp } = useVersionCheck(5 * 60 * 1000);
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";

  if (!newVersionAvailable) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: 'auto' }}
        exit={{ opacity: 0, height: 0 }}
        transition={{ duration: 0.2 }}
      >
        <div className="relative overflow-hidden rounded-lg border border-primary/20 bg-gradient-to-br from-primary/5 via-background to-primary/5 p-3 shadow-sm w-full">
          {/* Animated border glow - subtle and slow */}
          <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-transparent via-primary/10 to-transparent pointer-events-none" 
               style={{
                 backgroundSize: '200% 100%',
                 animation: 'shimmer 5s linear infinite'
               }} 
          />
          <style>{`
            @keyframes shimmer {
              0% { background-position: -200% 0; }
              100% { background-position: 200% 0; }
            }
          `}</style>

          {!isCollapsed ? (
            <div className="flex items-center justify-between gap-3">
              <div className="space-y-0.5 flex-1 min-w-0">
                <p className="text-xs font-semibold leading-none">Update Available</p>
                <p className="text-[10px] text-muted-foreground leading-tight">
                  New improvements ready
                </p>
              </div>

              <Button
                onClick={refreshApp}
                size="icon"
                className="h-8 w-8 shrink-0"
                title="Refresh to update"
              >
                <RefreshCw className="h-4 w-4" />
              </Button>
            </div>
          ) : (
            // Collapsed state - just show icon button
            <Button
              onClick={refreshApp}
              size="icon"
              variant="ghost"
              className="h-8 w-8"
              title="Update available - Click to refresh"
            >
              <RefreshCw className="h-4 w-4 text-primary" />
            </Button>
          )}
        </div>
      </motion.div>
    </AnimatePresence>
  );
}

